import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["mediaClientConfig"];
import React, { useContext } from 'react';
import { MediaClientContext, MediaClientProvider } from '@atlaskit/media-client-react';
import { MediaImageV2Base } from './mediaImageV2Base';
var MediaImageWithMediaClient = function MediaImageWithMediaClient(_ref) {
  var mediaClientConfig = _ref.mediaClientConfig,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var mediaClientContext = useContext(MediaClientContext);
  if (mediaClientContext) {
    return /*#__PURE__*/React.createElement(MediaImageV2Base, otherProps);
  }
  return /*#__PURE__*/React.createElement(MediaClientProvider, {
    clientConfig: mediaClientConfig
  }, /*#__PURE__*/React.createElement(MediaImageV2Base, otherProps));
};
export default MediaImageWithMediaClient;